import classnames from "classnames";
import * as React from "react";
class DockContent extends React.Component {
    render() {
        const { prefixCls } = this.props;
        const wrapCls = classnames(prefixCls);
        return <div className={wrapCls}>{this.createDockContent()}</div>;
    }
    dockable(d) {
        // otherwise try to find from existing dockables
        let jsx = d.jsx;
        if (jsx === undefined) {
            // something is wrong, no valid JSX nor CSS found
            if (d.style === undefined)
                jsx = <span>{"?"}</span>;
            else {
                // CSS string or React style ?
                if (typeof d.style === "string")
                    jsx = <div className={d.style}></div>;
                else
                    jsx = <div style={d.style}></div>;
            }
        }
        if (d.style !== undefined) {
            // CSS string or React style ?
            if (typeof d.style === "string")
                return <div className={d.style}>{jsx}</div>;
            else
                return <div style={d.style}>{jsx}</div>;
        }
        if (jsx instanceof Array)
            return <div className={`${this.props.prefixCls}-sub`}>{jsx}</div>;
        return jsx;
    }
    createDock(dock, dockbar, container, style, last = false) {
        const userCSS = typeof style === "string" ? style : "";
        const userStyle = typeof style !== "string" ? style : undefined;
        const preContainer = `pm-container`;
        const preDockbar = `pm-dockbar`;
        const containerCls = classnames(preContainer, {
            [`${preContainer}-top`]: dock === "top",
            [`${preContainer}-right`]: dock === "right",
            [`${preContainer}-bottom`]: dock === "bottom",
            [`${preContainer}-left`]: dock === "left",
            [`${preContainer}-last`]: last,
        });
        const dockbarCls = classnames(preDockbar, userCSS, {
            [`${preDockbar}-top`]: dock === "top",
            [`${preDockbar}-right`]: dock === "right",
            [`${preDockbar}-bottom`]: dock === "bottom",
            [`${preDockbar}-left`]: dock === "left",
        });
        return (<div className={containerCls}>
        <div className={dockbarCls} style={userStyle}>
          {dockbar}
        </div>
        {container}
      </div>);
    }
    createDockContent() {
        // how the dockbar(s) around the main view are arranged
        let key = 1;
        const dock = this.props.layout.map(e => {
            return {
                dock: e.dock,
                style: e.style,
                jsx: e.dockables.map(d => React.cloneElement(this.dockable(d), { key: key++ })),
            };
        });
        if (dock.length > 0) {
            const create = (d) => {
                const first = d[0];
                if (d.length === 1)
                    return this.createDock(first.dock, first.jsx, this.props.children, first.style, true);
                return this.createDock(first.dock, first.jsx, create(d.splice(1)), first.style);
            };
            return create(dock);
        }
        return this.props.children;
    }
}
DockContent.defaultProps = {
    prefixCls: "pm-dock",
};
export default DockContent;
